module.exports = __webpack_public_path__ + "static/img/ICON01@2x.e1340a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICON01@2x.png
// module id = rhOT
// module chunks = 1